




import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {IdMapper} from "../../../../../interfaces/state/base";
import {LadingCodeStatus} from "../../../../../enums/status";

@Component({
  name: "LadingCodeStatusLabel"
})
export default class extends mixins(CommonMixin) {
  @Prop({ required: true })
  readonly status!: number;

  LadingCodeStatus = LadingCodeStatus;
  colorMap: IdMapper<string> = {
    [LadingCodeStatus.Active]: 'success',
    [LadingCodeStatus.InActive]: 'error'
  }
}
